import * as React from 'react'

import { createContext } from '~logic/lib/react'

import { useProductListSelection } from '../hooks/useProductListSelection'

type TSelectionProps = Parameters<typeof useProductListSelection>[0]

type TContextValue = ReturnType<typeof useProductListSelection>

const [
  Provider, //
  useProductListSelectionCtx,
] = createContext<TContextValue>(`ProductListSelection`)

type TProps = RequiredChildren & TSelectionProps

/**
 * Provides the `selectedId` and `onSelection` callback to handle the selected product-list category.
 * Handles the intersection observer for the category navigation.
 */
export const ProductListSelectionProvider: React.FC<TProps> = ({
  children,
  dependencyData,
  stuckContentHeight,
}) => {
  const contextValue = useProductListSelection({ stuckContentHeight, dependencyData })

  return <Provider value={contextValue}>{children}</Provider>
}

export { useProductListSelectionCtx }
